import React from 'react';
import { LoginContext } from '../../../../services/api/authentication-api';
import './tasks-audit-trail-comment.scss';



class AuditTrailComment extends React.Component {

    constructor(Props) {
        super(Props);
        this.commentRef = React.createRef();

        let tags = [];

        this.state = {
        }
    }
    
    componentDidMount = () => {
        this.checkOverflow()
    }

    //This component doesn't unmount/remount when new entries are added, check comment prop to see if we need to check for overflow again
    componentDidUpdate = (prevProps) =>{
        if (prevProps.comment !== this.props.comment){
            this.checkOverflow()
        }
    }

    checkOverflow = () => {
        let node = this.commentRef.current;
        if (node !== undefined) {
            if(node.clientHeight !== 0){
                if(node.scrollHeight > node.clientHeight){
                    this.props.clipped(this.props.index);
                }
            }
        }
    }
    render = () => {
        let {comment} = this.props
        // Sometimes, an empty comment is given as null, we convert these into empty strings
        comment = comment ?? ""

        return (
            <div>
                <div id="comment-text" className={comment !== "" && comment !== null && (comment.substring(0, 1) !== "<" && comment.substring(comment.length - 2, comment.length)) ? "comment-description-cut-panel" : "no-comments"}>
                    <div className={comment.substring(0, 1) === "<" || comment === "" ? "comment-grey-text" : "comment-text-link"} ref={this.commentRef} >
                        {comment !== "" ? comment : "<No comments entered>"}
                        
                    </div>
                    
                </div>
            </div>

        )
    }



}

AuditTrailComment.contextType = LoginContext;
export default AuditTrailComment;